<template>
  <div class="accounts-list-page">
    <!-- Добавляем индикатор обновления данных в фоне -->
    <div class="update-indicator" v-if="isUpdating">
      <span class="update-text">{{ $t("global.updating") }}</span>
    </div>
    <div
      v-if="accountItems && accountItems.length > 0"
      class="accounts-container"
    >
      <div
        v-for="account in accountItems"
        :key="account.id || account.accountNumber"
        class="account-card"
        @click="openAccount(account)"
      >
        <div class="account-details">
          <div class="account-number">
            № {{ account.id || account.accountNumber }}
          </div>
          <div class="account-fio" v-if="account.fio">{{ account.fio }}</div>
          <div class="account-address" v-if="account.address">
            {{ account.address }}
          </div>
        </div>
        <div class="arrow-container">
          <span class="arrow">›</span>
        </div>
      </div>
    </div>

    <div v-else class="empty-message">
      {{ $t("components.accounts.empty") }}
    </div>

    <div class="add-account-btn-container">
      <button @click="goToAddAccount">
        {{ $t("components.accounts.add") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountsListPage",
  data() {
    return {
      isUpdating: false,
      localAccounts: [],
      // Добавляем новое свойство для трекинга первого запуска
      isFirstAppLoad: true,
    };
  },
  computed: {
    accountItems() {
      // Если есть локальные счета, используем их, иначе берем из хранилища
      if (this.localAccounts && this.localAccounts.length > 0) {
        return this.localAccounts;
      }

      const accs = this.$store.state.Auth.accounts;
      return Array.isArray(accs) ? accs : Object.values(accs || {});
    },
  },

  watch: {
    // Позволяет отслеживать изменения в аккаунтах без сайд-эффектов в computed
    "$store.state.Auth.accounts": {
      handler(newAccounts) {
        const accounts = Array.isArray(newAccounts)
          ? newAccounts
          : Object.values(newAccounts || {});

        if (accounts && accounts.length > 0) {
          this.localAccounts = [...accounts];
          // Если только один счет, и это не добавление нового, открываем его автоматически
          // ОТКЛЮЧЕНО: Пользователь должен оставаться на странице списка счетов
          // if (accounts.length === 1 && !this.$route.query.newAccount) {
          //   this.openAccount(accounts[0]);
          // }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // При монтировании сразу загружаем счета из локального хранилища
    try {
      const cachedAccounts = localStorage.getItem("accounts");
      if (cachedAccounts) {
        const accounts = JSON.parse(cachedAccounts);
        if (
          accounts &&
          (Array.isArray(accounts)
            ? accounts.length > 0
            : Object.keys(accounts).length > 0)
        ) {
          console.log("Загрузка счетов из localStorage в компоненте");
          this.localAccounts = Array.isArray(accounts)
            ? accounts
            : Object.values(accounts);
        }
      }
    } catch (e) {
      console.error(
        "Ошибка при загрузке счетов из localStorage в компоненте:",
        e
      );
    }
  },
  created() {
    // Проверяем, был ли уже запуск приложения
    const appStarted = sessionStorage.getItem("app_started");
    const freshLogin = sessionStorage.getItem("freshLogin");

    if (!appStarted || appStarted !== "true") {
      // Только при первом запуске приложения выполняем запрос
      console.log(
        "Первый запуск приложения, запускаю обновление списка счетов"
      );
      sessionStorage.setItem("app_started", "true");

      // Не делаем запрос если это новый вход
      if (freshLogin !== "true") {
        this.updateAccountsInBackground();
      } else {
        console.log("Обнаружен новый вход, пропускаю обновление счетов");
      }
    } else {
      console.log("Повторный вход на страницу, не выполняю запрос на bills");
    }

    if (this.$route.query.newAccount) {
      this.isLoading = true;
      this.loaderText = this.$t("addAccount.addingInProgress");
    }
  },

  methods: {
    // Метод для фонового обновления списка счетов
    updateAccountsInBackground() {
      // Проверяем наличие учетных данных
      if (this.$store.state.Auth.userCredentials && !this.isUpdating) {
        // Добавляем небольшую задержку перед показом индикатора для лучшей видимости
        setTimeout(() => {
          this.isUpdating = true;
        }, 300);

        // Запрашиваем обновленные данные счетов с сервера
        setTimeout(() => {
          this.$store
            .dispatch("Auth/getUserAccounts")
            .then(() => {
              console.log("Список счетов успешно обновлен в фоне");
              // Обновляем локальные счета после получения новых данных
              const accounts = this.$store.state.Auth.accounts;
              if (accounts) {
                this.localAccounts = Array.isArray(accounts)
                  ? [...accounts]
                  : Object.values(accounts);
              }
            })
            .catch((error) => {
              console.error("Ошибка при обновлении счетов в фоне:", error);
              // Просто скрываем индикатор обновления и работаем с кешированными данными без уведомления
              this.isUpdating = false;
            })
            .finally(() => {
              // Увеличиваем задержку до 3 секунд, чтобы индикатор был лучше виден
              setTimeout(() => {
                this.isUpdating = false;
              }, 3000); // Показываем индикатор в течение 3 секунд
            });
        }, 500); // Задержка перед запросом новых данных
      }
    },

    /**
     * ✅ ОБНОВЛЕНО: Открытие счета с передачей account_id в API
     */
    openAccount(account) {
      // ✅ Логируем информацию о выбранном счете
      console.log("--- Выбран счет ---");
      console.log("Объект счета:", account);
      console.log(
        `Номер: ${account.id || account.accountNumber}, ФИО: ${
          account.fio || "N/A"
        }`
      );
      console.log("--------------------");

      // Получаем корректный идентификатор счета для передачи в API
      const account_id = account.id || account.accountNumber || account.ls;
      console.log("Идентификатор счета для API:", account_id);

      // NEW: Сохраняем базовые данные в localStorage для мгновенной загрузки
      const preliminaryData = {
        ls: account_id,
        fio: account.fio,
        address: account.address,
      };
      localStorage.setItem(
        "preliminaryAccountData",
        JSON.stringify(preliminaryData)
      );

      // 1. Сохраняем в состояние тот счет, на который кликнули с правильным ls
      const accountToSet = {
        ...account,
        ls: account_id,
      };
      this.$store.commit("Auth/SET_ACCOUNT", accountToSet);

      // 2. Задаем статус загрузки ДО перехода на главную страницу
      this.$store.commit("Auth/SET_STATUS", "loading");

      // 3. Сразу переходим на главную страницу
      // NOTE: fetchAndScrapeAccountDetails будет вызван в Home.vue в методе created()
      this.$router.push({ name: "Home" });
    },
    goToAddAccount() {
      this.$router.push({ name: "AddAccount" });
    },
  },
};
</script>

<style scoped>
.accounts-list-page {
  min-height: 100vh;
  padding: 16px;
  color: #ecf0f1;
}

/* Удалены стили для кнопки обновления */

/* Удален стиль для заголовка */

/* Удалены стили для оффлайн-уведомления */

.accounts-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.account-card {
  background: #0e121c; /* ✅ Новый темный фон */
  border-radius: 12px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.account-card:hover {
  background-color: #2a2c2d; /* ✅ Новый фон при наведении */
}

.account-details {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.account-number {
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
}

.account-fio,
.account-address {
  font-size: 16px;
  color: #bdc3c7;
}

.arrow {
  font-size: 28px;
  color: #4277f5;
  font-weight: bold;
}

.empty-message {
  text-align: center;
  color: #95a5a6;
  font-size: 16px;
  margin-top: 50px;
}

.add-account-btn-container {
  margin-top: 30px;
  text-align: center;
}

.add-account-btn-container button {
  background-color: #4277f5;
  color: #fff;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
}

.add-account-btn-container button:hover {
  background-color: #4277f5;
}

.update-indicator {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #0e121c;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  z-index: 100;
  animation: slide-down 0.3s ease-out;
}

.update-text {
  font-weight: 700;
  font-size: 13px;
  animation: fade-in-out 2s infinite;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@keyframes slide-down {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes fade-in-out {
  0%,
  100% {
    opacity: 0.4;
    color: rgba(255, 255, 255, 0.7);
  }
  50% {
    opacity: 1;
    color: #ffffff;
  }
}
</style>
